import React, { createContext, useContext, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const SiteNoticeContext = createContext({
  active: false,
  text: '',
  barHeight: 0,
  setBarHeight: () => {},
});

export const useSiteNotice = () => useContext(SiteNoticeContext);

export function SiteNoticeProvider({ children }) {
  const [notice, setNotice] = useState({ active: false, text: '' });
  const [barHeight, setBarHeight] = useState(0);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/settings/public/site-notice`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d) setNotice({ active: !!d.active, text: d.text || '' });
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <SiteNoticeContext.Provider value={{ ...notice, barHeight, setBarHeight }}>
      {children}
    </SiteNoticeContext.Provider>
  );
}
